import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import LogoHeader from "../../../ressources/images/besse-immobilier-construction.jpg";
import logoLabelisation from "../../../ressources/images/labelisationFI.png";
import logo from "../../../ressources/images/logo_vertuloo_v.png";
import styles from "../styles";

const HeaderStatique: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [width, setWidth] = useState(window.screen.width);

  useEffect(() => {
    const updateWindowDimensions = () => setWidth(window.screen.width);
    window.addEventListener("resize", updateWindowDimensions);
    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  const navigate = useNavigate();
  const handleConnexion = () => {
    navigate("/dashboard");
    if (window.MatomoTagManager) {
      window._paq.push([
        "trackEvent",
        "Connexion",
        "Clic - CTA",
        "Accueil - Menu Connexion",
      ]);
    }
  };

  const handleContact = () => navigate("/contact");

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setMenuOpen(open);
    };

  const sideList = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      className="liensResponsive"
    >
      <List>
        <ListItem button>
          <a href="/">Vertuloo</a>
        </ListItem>
        <ListItem button>
          <a href="/en-savoir-plus">En savoir plus</a>
        </ListItem>
        <ListItem button>
          <a href="/#contact">Contact</a>
        </ListItem>
        <ListItem button>
          <ListItemText onClick={handleConnexion} primary="Mon espace client" />
        </ListItem>
      </List>
      <Divider />
    </div>
  );

  const path = window.location.pathname;

  return (
    <Box className="headerContainer" sx={styles}>
      <div className="header">
        <div className="logoContainer">
          <a href="/" onClick={() => console.log("Logo clicked")}>
            <div className="logo">
              <img
                src={LogoHeader}
                alt="Logo Besse Immobilier et Construction"
              />
            </div>
          </a>
          <a href="/labelisation" onClick={() => console.log("Lab clicked")}>
            <div className="logoLab">
              <img
                src={logoLabelisation}
                alt="Labelisation Finance Innovation"
              />
            </div>
          </a>
        </div>
        <div className="menu">
          <div className="menuResponsive">
            <IconButton aria-label="menu" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              open={menuOpen}
              onClose={toggleDrawer(false)}
              sx={{ paper: "leftToggle" }}
            >
              {sideList()}
            </Drawer>
          </div>
          <div className="menuNormal">
            <a href="/" className={path === "/" ? "activeLink" : ""}>
              Vertuloo
            </a>
            <a
              href="/en-savoir-plus"
              className={path === "/en-savoir-plus" ? "activeLink" : ""}
            >
              En savoir plus
            </a>
            <a href="/#contact">Contact</a>
            <div className="connexionContainer">
              <Button className="connexionButton" onClick={handleConnexion}>
                <span>
                  Mon espace
                  <br />
                  client
                </span>
                <img src={logo} width={45} alt="Vertuloo" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default HeaderStatique;
